var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "display": "contents"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": true,
      "hide-overlay": "",
      "transition": "none",
      "eager": "",
      "content-class": "access-password-dialog",
      "max-width": "800px",
      "persistent": "",
      "no-click-animation": ""
    }
  }, [_c('v-overlay', {
    staticClass: "acccess-password-overlay",
    attrs: {
      "absolute": "",
      "color": "#071441E5",
      "opacity": "0.5",
      "z-index": "1",
      "value": _vm.dialog
    }
  }), _c('v-card', {
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('v-card-title', [_vm._v(" Enter Password to Access ")]), _c('v-card-subtitle', [_vm._v(" Please enter the password to get access ")]), _c('v-card-text', [_c('div', {
    staticClass: "access-password-label"
  }, [_vm._v(" Password ")]), _c('v-text-field', {
    attrs: {
      "type": "password",
      "outlined": "",
      "hide-details": "auto",
      "error": !!_vm.errorMessage,
      "error-messages": _vm.errorMessage
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "x-large": ""
    },
    on: {
      "click": _vm.validatePassword
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }